import Vue from "vue";
import request from './request';
import { getToken, authVersion } from './storage';
export const accessState = Vue.observable({ permissions: [], roles: [], name: '', version: '' });
export const routeModules = {'dashboard': 'dashboard', 'customers': 'customers', 'purchase': 'purchases', 'shipment': 'shipments', 'freight-records': 'freight', 'debt-records': 'debts', 'daily-bill': 'bills', 'weighing': 'weighing', 'reverse-invoice': 'invoices', 'login-logs': 'logs', 'settings': 'settings'};
export function can(permission) { return !!getToken() && accessState.version === authVersion() && accessState.permissions.includes(permission); }
export function clearAccess() { accessState.permissions = []; accessState.roles = []; accessState.name = ''; }
export async function refreshAccess() {
  const version = authVersion();
  try {
    const res = await request.get('/api/access/me');
    if (version !== authVersion()) throw new Error('登录状态已变更，请重试');
    if (!getToken()) { clearAccess(); return; }
    accessState.permissions = res.data.permissions || [];
    accessState.roles = res.data.roles || [];
    accessState.version = authVersion();
    accessState.name = res.data.name || res.data.username;
  } catch (error) { if(version === authVersion()) clearAccess(); throw error; }
}
export function landing() {
  const path = Object.keys(routeModules).find(key => can(routeModules[key] + ':view'));
  return path ? '/' + path : can('users:view') || can('roles:view') ? '/access-management' : '/workspace';
}
